module.exports = __webpack_public_path__ + "static/img/undraw_news_go0e.b3db948.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/undraw_news_go0e.svg
// module id = 9tKZ
// module chunks = 1